import React, { useEffect } from 'react';
import PageHeader, {
  BackLink,
  BackLinkProps,
  PageHeaderProps,
} from 'components/PageHeader/PageHeader';

export const ShowCommentBackLink = ({ backLink }: BackLinkProps) => {
  const [backTarget, setBackTarget] = React.useState(backLink);

  useEffect(() => {
    if (document.referrer && /\/comments[/?]+/.test(document.referrer)) {
      setBackTarget(document.referrer);
    }
  }, []);
  return <BackLink backLink={backTarget} />;
};

export const IndexCommentBackLink = ({ backLink }: BackLinkProps) => {
  // When the referrer is known (and is not a discussion list page or discussion page) it is stored in local storage
  // Use this stored referrer for back link or default to url (the guideline page or the review page depending on the user access)
  const [backTarget, setBackTarget] = React.useState(backLink);

  // Run only once on first render to set up session storage tracking
  useEffect(() => {
    if (
      document.referrer &&
      !/\/comments[/?]+/.test(document.referrer) &&
      !/\/sign_in/.test(document.referrer)
    ) {
      sessionStorage.setItem('discussions_list_referrer', document.referrer);
      setBackTarget(document.referrer);
    } else {
      const stored_back_url = sessionStorage.getItem(
        'discussions_list_referrer'
      );
      if (stored_back_url) {
        setBackTarget(stored_back_url);
      }
    }
  }, []);

  return <BackLink backLink={backTarget} />;
};

export const CommentShowPageHeader = (props: PageHeaderProps) => {
  return <PageHeader backLinkComponent={ShowCommentBackLink} {...props} />;
};

export const CommentIndexPageHeader = (props: PageHeaderProps) => {
  return <PageHeader backLinkComponent={IndexCommentBackLink} {...props} />;
};
